import React from 'react';

import styles from './PageSectionTitleWithActions.module.scss';

const PageSectionTitleWithActions = ({ text, actions }) => {
  return (
    <div className={styles.pageSectionTitleWithActions}>
      <h3 className={styles.pageSectionTitle}>
        {text}
      </h3>
      <div className={styles.actions}>
        {actions}
      </div>
    </div>
  );
};

export default PageSectionTitleWithActions;